var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "128px",
    height: "128px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#2e315b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9090909090909091s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(32.72727272727273 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#f8d5c6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8181818181818182s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(65.45454545454545 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#984a98"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7272727272727273s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(98.18181818181819 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#d673a8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6363636363636364s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(130.9090909090909 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#f598b7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5454545454545454s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(163.63636363636363 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#aea7b2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.45454545454545453s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(196.36363636363637 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#dda682"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.36363636363636365s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(229.0909090909091 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#8c6863"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.2727272727272727s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(261.8181818181818 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#2e315b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.18181818181818182s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(294.54545454545456 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#f8d5c6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.09090909090909091s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(327.27272727272725 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    rx: 3,
    ry: 8,
    width: 6,
    height: 16,
    fill: "#984a98"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.8785715b4767f48087a975eeeabfb440.svg";
export { ForwardRef as ReactComponent };